export const API_ROOT = '/api/authpresentation';
export const GET_SSO_CONFIG = '/configuration/getssoconfig';
export const PROCESS_SSO = '/token/processSso'

export const ACCOUNT_USER = 'token';
export const ACCOUNT_CHANGE_PASSWORD = 'account/password';
export const ACCOUNT_RESET_PASSWORD = 'account/resetpassword';

// Requires UserName
export const ACCOUNT_FORGOT_PW = 'account/forgotpassword';

// Requires UserName & Password
export const ACCOUNT_FORGOT_PW_CONFIRM = 'account/forgotpassword/confirm';

export const ACCOUNT_LOGIN = 'token';
export const VALIDATE_MFA_CODE = 'token/validatemfa';
export const ACCOUNT_LOGOUT = 'account/logout';

export const LOGIN_HELP_TEXT = '/home/getlogintext';
export const LOGIN_BACKGROUND_IMG = '/home/getbackground';
